/**
 * Owner-facing advice fields on a journal («Hjemsendelsesråd»).
 *
 * TICKET-01660: clinics want to hand the owner a separate sheet with the
 * home-care advice after operations / dental work instead of the whole
 * journal. These are the three fields the help article on hjemsendelsesråd
 * points clinics to; journalPrint.js prints exactly these when `adviceOnly`
 * is set, and the print buttons are disabled while all of them are empty.
 */
const ADVICE_FIELDS = ['clientCommunication', 'recommendations', 'followUp'];

function hasClientAdvice(journal) {
    if (!journal) return false;
    return ADVICE_FIELDS.some(field => typeof journal[field] === 'string' && journal[field].trim() !== '');
}

export { ADVICE_FIELDS, hasClientAdvice };
export default { ADVICE_FIELDS, hasClientAdvice };
